var map = {
	"./1_x1.png": "43df",
	"./1_x2.png": "d945",
	"./1_x4.png": "595b",
	"./1_x7.png": "73cf",
	"./2_x2.png": "8beb",
	"./2_x4.png": "b086",
	"./2_x6.png": "3716",
	"./2_x8.png": "640e",
	"./3_x12.png": "71ee",
	"./3_x3.png": "662d",
	"./3_x6.png": "6aaf",
	"./3_x9.png": "afaf",
	"./4_x12.png": "3b79",
	"./4_x16.png": "96cd",
	"./4_x4.png": "138f",
	"./4_x8.png": "80c7",
	"./normal_multiplier_1.png": "1263",
	"./normal_multiplier_2.png": "1475",
	"./normal_multiplier_4.png": "f2ba",
	"./normal_multiplier_7.png": "f021",
	"./symbol_0.png": "b419",
	"./symbol_1.png": "1328",
	"./symbol_10.png": "9cc2",
	"./symbol_11.png": "3400",
	"./symbol_12.png": "5ba73",
	"./symbol_13.png": "817e",
	"./symbol_14.png": "0ad2",
	"./symbol_15.png": "4a0f",
	"./symbol_16.png": "2c91",
	"./symbol_17.png": "49ee",
	"./symbol_2.png": "eaf9",
	"./symbol_3.png": "785b",
	"./symbol_4.png": "c7b2",
	"./symbol_5.png": "926b",
	"./symbol_6.png": "d470",
	"./symbol_7.png": "7229",
	"./symbol_8.png": "cd86",
	"./symbol_9.png": "6903"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d83";